import React from 'react';
import { useUser } from '../contexts/UserContext';

/**
 * Componente que permite ao usuário alternar entre diferentes salões
 * @returns {JSX.Element} Componente de seleção de salão
 */
const SalonSelector = () => {
  const { userSalons, selectedSalonId, switchSalon, loading } = useUser();
  
  if (loading) {
    return (
      <div className="p-2 bg-gray-50 border-b border-gray-200">
        <div className="animate-pulse h-8 bg-gray-200 rounded"></div>
      </div>
    );
  }
  
  if (userSalons.length <= 1) {
    return null; // Não mostrar se houver apenas um salão
  }
  
  // Função para formatar o texto de role
  const formatRole = (role) => {
    const roles = {
      'admin': 'Administrador',
      'owner': 'Proprietário',
      'manager': 'Gestor',
      'professional': 'Profissional'
    };
    
    return roles[role] || role;
  };
  
  return (
    <div className="p-3 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto">
        <label htmlFor="salon-selector" className="block text-sm font-medium text-gray-700 mb-1">
          Selecionar Salão
        </label>
        <div className="relative">
          <select
            id="salon-selector"
            className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
            value={selectedSalonId || ''}
            onChange={(e) => switchSalon(e.target.value)}
          >
            {userSalons.map((salon) => (
              <option key={salon.id} value={salon.id}>
                {salon.name || salon.id} ({formatRole(salon.role)})
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
        <p className="mt-1 text-xs text-gray-500">
          Você tem acesso a {userSalons.length} {userSalons.length === 1 ? 'salão' : 'salões'}
        </p>
      </div>
    </div>
  );
};

export default SalonSelector; 